import React, { Component } from 'react';

import './MinimizeButton.css'
export class MinimizeButton extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className='minimizeButton' 
            style={{ 
                width: this.props.width ? this.props.width : '35px', 
                height: this.props.height ? this.props.height : '35px',
                lineHeight: `${this.props.height ? this.props.height-8 : 35}px`
            }}
            onClick={this.props.onClick}>
                <div className='minimizeButton__content'
                    style={{
                        width: `${this.props.width ? 0.75*this.props.width : 26}px`,
                    }}/>
            </div>
        );
    }
}